export default __webpack_public_path__ + "static/desktop-mobile-2316b5d46b546d733e4dc66dd21cf205.png";